import { render, staticRenderFns } from "./bodyEstimator.vue?vue&type=template&id=79ac86f3&scoped=true"
import script from "./bodyEstimator.vue?vue&type=script&lang=js"
export * from "./bodyEstimator.vue?vue&type=script&lang=js"
import style0 from "./bodyEstimator.vue?vue&type=style&index=0&id=79ac86f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac86f3",
  null
  
)

export default component.exports